import styled, { keyframes } from "styled-components";

export const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const PremiumPubMenuWrapper = styled.div`
  position: fixed;
  right: 16px;
  bottom: 30px;
  z-index: 10;
  width: calc(100% - 32px);
  height: 60px;
  border-radius: 75px;
  background: #2f3332;
  display: flex;
  padding: 0 35px;
  gap: 20px;
`;

export const PremiumPubMenuBackWrapper = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  animation: ${fadeInUp} 0.3s ease-out forwards;
  overflow: hidden;
  touch-action: none;
  overscroll-behavior: contain;
`;

export const PremiumPubFloatingWrapper = styled.div<{ isOpen: boolean }>`
  position: fixed;
  left: 50%;
  bottom: 100px;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-evenly;
  transition: all 0.3s ease-in-out;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  visibility: ${(props) => (props.isOpen ? "visible" : "hidden")};
  transform: translateX(-50%),
    ${(props) => (props.isOpen ? "translateY(0)" : "translateY(20px)")};
  &::before {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
  }
`;

export const PremiumPubFloatingItem = styled.div<{ count: number }>`
  cursor: pointer;
  border-radius: 45px;
  width: 50px;
  height: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #613eea;
  backdrop-filter: blur(24px);
  animation: ${fadeInUp} 0.3s ease-out forwards;
  opacity: 0;
  position: relative;

  &:nth-child(1) {
    animation-delay: 0.1s;
    ${(props) => (props.count === 5 ? "left: 50px" : "")};
  }
  &:nth-child(2) {
    animation-delay: 0.2s;
    ${(props) => (props.count === 5 ? "left: 25px" : "")};
    bottom: ${(props) => (props.count === 4 ? "25px" : "50px")};
  }
  &:nth-child(3) {
    animation-delay: 0.3s;
    bottom: ${(props) => (props.count === 4 ? "25px" : "0")};
  }
  &:nth-child(4) {
    animation-delay: 0.4s;
    ${(props) => (props.count === 5 ? "right: 25px" : "")};
    bottom: ${(props) => (props.count === 4 ? "0" : "50px")};
  }
  &:nth-child(5) {
    ${(props) => (props.count === 5 ? "right: 50px" : "")};
    animation-delay: 0.5s;
  }

  > img {
    width: 17px;
    height: 17px;
    object-fit: contain;
  }

  > span {
    color: #fff;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.28px;
  }
`;

export const PremiumPubMenuItem = styled.div<{
  isSelected?: boolean;
  isOpen?: boolean;
}>`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: ${({ isOpen }) => (isOpen ? "1000" : "-1")};

  > .name {
    transition: all 0.5s;
    font-weight: 700;
    font-size: 9px;
    text-align: center;
    color: ${({ isSelected }) => (isSelected ? "white" : "#808080")};
  }
`;
